/**
 * Headers Archetype
 * 
 * @author [authorName]
 * @date 6 de Agosto, 2024
 * @version 1.0
 */
 
import _ from 'lodash'

const baseController = 'Lunchexhibidor'

const baseIndex = baseController + '/index'

const archetype = () => {
	return [
		// [hidden|number|price|phone|textarea|positivo|password|email]
		{
			key: 'id',
			type: 'hidden'
		},
        {key: 'logo_uri', label: 'Logo', type: 'imageurl'}, // 6		varchar(255)	utf8	utf8_unicode_ci	YES	NULL			
        {key: 'fotogorafia_uri', label: 'Fotografía (Referencia)', type: 'imageurl'}, // 7		varchar(255)	utf8	utf8_unicode_ci	YES	NULL			
        {key: 'exhibidor'}, // 2		varchar(160)	utf8	utf8_unicode_ci	NO	NULL			
        {key: 'exhibidor_uri', label: 'URL Hash'}, // 5		varchar(32)	utf8	utf8_unicode_ci	NO	NULL			
        {key: 'estatus', options: ['Activo','Inahbilitado'], type: 'select'}, // 8		"enum('Activo','Inahbilitado')"	utf8	utf8_unicode_ci	YES	NULL			
        [
            {key: 'created', readonly: true}, // 3		datetime	NULL	NULL	YES	NULL			
            {key: 'modified', readonly: true}, // 4		datetime	NULL	NULL	YES	NULL			
        ],
        {key: 'inventarioCFG', type: 'hidden'}
	]
};

const captions = [
    {key: 'exhibidor'},
    {key: 'exhibidor_uri', label: 'URL Hash'},
    {key: 'estatus'},
    {key: '_'},
]

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId) );
    // console.log("isNil", _.isNil(conceptId))
    return str;
}


export {
    archetype,
    captions,
    baseIndex,
    automodalHandler
}